/**
 * Procedure Categories and Procedures for DM in Geriatric Mental Health students
 * Extracted with strict evidence from official NMC PDF (Page 8-9: "Psychomotor Domain - perform independently")
 */
export const GERIATRIC_MENTAL_HEALTH_PROCEDURES = {
  "Geriatric Somatic & Brain Stimulation Procedures": [
    "Electroconvulsive Therapy (ECT) Administration in Elderly Patients",
    "Repetitive Transcranial Magnetic Stimulation (rTMS) Therapy",
    "Transcranial Direct-Current Stimulation (TDCS) Therapy",
    "Emergency Management of Acute Psychotropic Toxicity (NMS & Acute Dystonia)",
  ],
  "Geriatric Neuropsychological & Psychotherapeutic Procedures": [
    "Comprehensive Geriatric Neuropsychological Battery (MMSE, MoCA, HMSE, CDR, NPI)",
    "Cognitive & Behavioral Therapy (CBT & Behavioral Management in Dementia)",
    "Interpersonal Therapy (IPT), Problem-Solving Therapy (PST) & Reminiscence Therapy",
    "Geriatric Capacity Assessment & Decision-Making Evaluations",
  ],
};

export const GERIATRIC_MENTAL_HEALTH_CATEGORIES = Object.keys(GERIATRIC_MENTAL_HEALTH_PROCEDURES);

export const isDMInGeriatricMentalHealthDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return d.includes("geriatric mental health") || d.includes("geriatric psychiatry");
};
